import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { I18nModule, UrlModule, ConfigModule, CmsConfig, provideConfig } from '@spartacus/core';
import { PageLayoutModule, OutletModule, OutletRefModule, PageSlotModule, AppRoutingModule } from '@spartacus/storefront';

import { KbHeaderLanguageComponent } from './kb-header-language.component';
import { LangSubComponent } from './lang-sub/lang-sub.component';



@NgModule({
  declarations: [KbHeaderLanguageComponent, LangSubComponent],
  imports: [
    CommonModule,
    PageLayoutModule,
    OutletModule,
    OutletRefModule,
    PageSlotModule,
    I18nModule,
    UrlModule,
    RouterModule,
    AppRoutingModule,
    
  ],
    providers: [
      provideConfig({
        cmsComponents: {
          LanguageChangeComponent: {
            component: KbHeaderLanguageComponent,
           
          },
        },
      }),
    ],
  exports: [KbHeaderLanguageComponent]
})

export class KbHeaderLanguageModule { }
